module.exports = {
  myOrder: {
    AllOrders: 'All Orders',
    PendingPayment: 'Pending Payment', // 201
    AwaitingShipment: 'Awaiting Shipment',
    PendingReceipt: 'Pending Receipt',
    Completed: 'Completed',
    ProductNumber: 'Product Name/Order Number',
    ProductInformation: 'Product Information',
    Quantity: 'Quantity',
    Total: 'Total',
    Status: 'Status',
    Operating: 'Operating',
    YouHave: 'You haven’t placed any orders yet!',
    WillBe: 'All your orders will be saved here for you to access their status anytime.',
    OrderDate: 'Order Date',
    OrderNumber: 'Order Number',
    Seller: 'Seller',
    RemainingTime: 'Remaining Time',
    Theproducts: 'The products below are out of stock',
    belowAre: 'The products below are out of stock.',
    DoYou: 'Do you want to add the available products to the shopping cart first?',
    Cancel: 'Cancel',
    Submit: 'Submit',
    RefundAfTe: 'Select the device you need to Refund Orders',
    Items: 'All Of The Items',
    Shipped: 'Shipped',
    SuccessfulTransaction: 'Successful Transaction',
    Cancelled: 'Cancelled',
    TradingClosed: 'Sale closed',
    PayNow: 'Pay Now',
    OrderDetails: 'Order Details',
    ChangeAddress: 'Change Address',
    CancelOrder: 'Cancel Order',
    Refund: 'Refund',
    ConfirmReceipt: 'Confirm Receipt',
    Remove: 'Remove',
    AfterSale: 'Refund',
    BuyAgain: 'Buy Again',
    BeReplaced: 'Please select the address to be replaced!',
    modified: 'Address modified successfully!',
    Modify: 'Modify delivery address',
    EachOrderCan: 'Each order can only modify the delivery address once, because different regions have different sales taxes, so modifying the address will affect the final price of the order.',
    TheOrder: 'The original shipping address of the order',
    Name: 'Name',
    Address: 'Address',
    ZipCode: 'Zip Code',
    PhoneNumber: 'Phone Number',
    OrChoose: 'Or choose a new shipping address',
    AddRess: 'Add New Delivery Address',
    Cancellation: 'Are you sure to cancel the order? Cancellation of an order cannot be reinstated.',
    CancelThe: 'Cancel Order Reminder',
    successfully: 'Cancel the order successfully!',
    order_After: 'Are you sure you want to delete the after-sales order data? The data cannot be restored after it is deleted.',
    Reminder: 'Delete Order Reminder'
  },
  orderAfterSale: {
    AfterSale: 'Refund Orders',
    ProductName: 'Product Name/Order Number',
    ProductInformation: 'Product Information',
    Quantity: 'Quantity',
    Total: 'Total',
    Status: 'Status',
    Operating: 'Operating',
    YouCurrently: 'You currently do not have any refund orders.',
    OrderDate: 'Order Date',
    OrderNumber: 'Refund number',
    PendingSellerReview: 'Pending Seller Review',
    WaitingForReturn: 'Waiting For Return',
    PendingSellerRefund: 'Pending Seller Refund',
    UserDisagrees: 'User Disagrees',
    PendingUserConsent: 'Pending User Consent',
    CompleteAfterSales: 'Refund Complete',
    Terminated: 'Terminated',
    UserRevoked: 'User Revoked',
    Closed: 'Closed',
    RevokeApplication: 'Revoke Application',
    ModifyApplication: 'Modify Application',
    ReturnItems: 'Return Items',
    Order_Details: 'Order Details',
    AgreeToRefund: 'Agree to refund',
    DisagreeToRefund: 'Disagree to refund',
    Remove: 'Remove',
    confirmButtonText: 'Confirm',
    cancelButtonText: 'Cancel',
    after_sales: 'Are you sure to withdraw this after-sales application?',
    SystemTips: 'System tips',
    removeThe: 'Are you sure you want to delete the order? After deleting, the data cannot be restored.',
    amount: 'Are you sure you agree to this refund amount?',
    refund_amoun: 'Are you sure you disagree with this refund amount?'
  },
  orderDetail: {
    OrderStatus: 'Order Status',
    OrderDetails: 'Order Details',
    Back: 'Back',
    OrderNumber: 'Order Number',
    OrderDate: 'Order Date',
    LogisticsInformation: 'Logistics Information',
    ShippingCarrier: 'Shipping Carrier',
    TrackingNumber: 'Tracking Number',
    RecipientInformation: 'Recipient Information',
    Name: 'Name',
    Address: 'Address',
    ZipCode: 'Zip Code',
    PhoneNumber: 'Phone Number',
    PaymentInformation: 'Payment Information',
    PaymentMethod: 'Payment Method',
    PaymentAccount: 'Card  Number',
    Payment_Account: 'Payment Account',
    PaymentTime: 'Payment Time',
    SellerInformation: 'Seller Information',
    ContactSeller: 'Contact Seller',
    ProductInformation: 'Product Information',
    Product: 'Product',
    Quantity: 'Quantity',
    Price: 'Price',
    Status: 'Status',
    Subtotal: 'Subtotal',
    Shipping: 'Shipping',
    SalesTax: 'Sales tax',
    TotalPayout: 'Order total',
    productsThe: 'The products below are out of stock',
    Theproducts: 'The products below are out of stock.',
    wantToAdd: 'Do you want to add the available products to the shopping cart first?',
    Cancel: 'Cancel',
    Submit: 'Submit',
    SendUsYour: 'We\'re here to help! Send us your message and our representative will get back to you as soon as possible',
    YourMessage: 'Your Message'
  },
  SubmitOrder: {
    PendingPayment: 'Pending Payment', // 201
    AwaitingShipment: 'Awaiting Shipment', // 202
    Shipped: 'Shipped',
    SuccessfulTransaction: 'Successful Transaction',
    Cancelled: 'Cancelled',
    TradingClosed: 'Sale closed',
    SubmitOrder: 'Submit Order',
    PaymentSuccessful: 'Payment Successful',
    CommodityDelivery: 'Commodity Delivery',
    WaitingForReceipt: 'Waiting For Receipt',
    Completed: 'Completed',
    successfully: 'Add to cart successfully'
  },
  RequestARefund: {
    After_Sale: 'Refund Orders',
    Back: 'Back',
    ProductInformation: 'Product Information',
    Quantity: 'Quantity',
    Price: 'Price',
    TotalPrice: 'Total Price',
    Type: 'Type',
    OnlyRefund: 'Only refund',
    RefundsAndReturns: 'Refunds and Returns',
    EnterContent: 'Please enter content',
    returned: 'item can be returned.',
    Maximum: 'Maximum',
    Reason: 'Reason',
    Description: 'Description',
    PleaseEnterContent: 'Please enter content',
    UploadImage: 'Upload Image',
    UploadUp: 'Upload up to 3 pictures, each picture size does not exceed 5M.',
    RefundAccount: 'Refund account',
    SubmitApplication: 'Submit application',
    choose: 'Please choose refund or return Reason!',
    description: 'Please fill in the refund description!',
    Paypal: 'Paypal'
  },
  Refund: {
    RefundDetails: 'Refund Details',
    Back: 'Back',
    Status: 'Status',
    Reason: 'Reason',
    SubmitApplication: 'Submit Application',
    SellerProcessing: 'Seller Processing',
    UserReturns: 'Return merchandise',
    SellerRefund: 'Seller Refund',
    RefundComplete: 'Refund Complete',
    MerchantProcessing: 'Merchant Processing',
    ProductInformation: 'Product Information',
    Quantity: 'Quantity',
    Price: 'Price',
    TotalPrice: 'Total Price',
    Shipping: 'Shipping',
    SalesTax: 'Sales Tax',
    Type: 'Type',
    Description: 'Description',
    UploadImage: 'Image',
    RefundAccount: 'Refund Account',
    SubmissionTime: 'Submission Time',
    RefundNumber: 'Refund Number',
    RevokeApplication: 'Revoke Application',
    ModifyTheApplication: 'Modify The Application',
    Complaint: 'Complaint',
    Paypal: 'Paypal',
    submitted: 'Your complaint has been successfully submitted, and there will be a dedicated customer service staff on the platform to help you later.',
    SystemTips: 'System Tips',
    Close: 'Close',
    RefundAmount: 'Refund Amount',
    information: 'Return Product Logistics Information',
    Logistics: 'Logistics Mode',
    Shipment: 'Shipment Number',
    pleaseReturn: 'The seller has agreed to your return application, please return as soon as possible',
    theTimeIs: 'Please fill in the real logistics information. If the time is exceeded, the return application will be automatically cancelled.',
    environmental: 'Tips: For environmental protection, if there are multiple devices, please try to put the devices in one package and send them out. When filling in the  return product logistics information, just fill in the same.',
    address: "Seller's delivery address",
    ProductLogistics: 'Add return product logistics information',
    LogisticsMode: 'Logistics Mode',
    ShipmentNumber: 'Shipment Number',
    Submit: 'Submit'
  },
  signingAddress: {
    Manage: 'Manage Your Shipping Addresses',
    personal: 'Add and make changes to the addresses you use regularly.',
    Delivery: 'Add New Delivery Address',
    YouHave: 'You have a limit of 10 shipping addresses, you can no longer add them, you can modify the added addresses.',
    TheNumber: 'The number of address has reached the limit',
    Youhaven: 'You haven’t added an address yet！',
    AddNew: 'Add a new address now, and enjoy the convenience of shopping whenever you want!',
    AddNewAddress: 'Add New Address'
  },
  message: {
    SystemNotification: 'System Notification',
    OrderNotification: 'Order Notification',
    SellerCustomerService: 'Seller Customer Service',
    Customer: 'Customer Service',
    SendUsyour: 'We\'re here to help! Send us your message and our representative will get back to you as soon as possible',
    yourMage: 'Your Message',
    Email: 'Email',
    IfYouPrefer: 'If you prefer to contact us directly via email instead of using our message board, please feel free to send anemail to support@yaytech.com.',
    Questions: 'Questions about the product?',
    IfYouHave: 'If you have any questions about a specific product, please feel free to use the product page to communicate directly with the seller. Sellers are usually very happy to help solve any problems.'
  },
  faq: {
    title: 'Hello,We’re here for you',
    text: 'We’ll walk you through fixing most things here, or connect you to someone if you need more help.',
    Buying: 'Buying',
    ReturnsRefunds: 'Returns & Refunds',
    Payment: 'Payment',
    LogisticsWarranty: 'Logistics & warranty'
  },
  Help: {
    title: 'How can we help you?',
    text: 'YayTech has fantastic support. Send us your information and our representative will reply to you shortly',
    Contact: 'Contact our support team',
    Office: 'Office Hours: Mon - Fri,8am-12pm (PST) Our customer care experts are standing by',
    Norton: '13771 Norton Ave, Chino, CA 91710',
    Get: 'Get directions',
    Email: 'Email us directly, and we\'ll respond right away.',
    Leave: 'Leave a message for us',
    IfYou: 'If you have any questions or want to leave feedback, fill out the form below. We will answer your questions as soon as possible.',
    FirstName: 'First Name',
    ContactEmail: 'Contact Email',
    LastName: 'Last Name',
    PhoneNumber: 'Phone Number',
    messageHere: 'Enter your message here.',
    send: 'Send'
  },
  About: {
    title: 'About YayTech',
    text: 'YayTech is a safe and simple second-hand equipment sales market.',
    S_story: "YayTech's story",
    second_hand: 'Based in Chino, California, YayTech swung it’s digital doors open in 2022. Following the earth rocking pandemic the need for refurbished devices has never been higher. Consumers became all too aware during the global pandemic how much they were reliant on their devices for work, school and play. People also became aware of the long term environmental impact of devices as the chip shortage proved that devices, just like every other product, are subject to resource limitations. At YayTech we repair and refurbish devices to resell, thus extending their lifecycle. By extending the life of products YayTech ensures that it is taking a tangible bite out of e-waste keeping devices out of landfills. As more people embrace educating their children or working from home, YayTech aims to make refurbished devices an affordable and quality option for everyone to enjoy. ',
    Wecan: 'We can provide iPhone, iPad, tablets, etc. that work like new devices at a lower price. And provide comprehensive warranty,fast delivery and first-class customer service. Most importantly, choosing to refurbish is good for the planet.',
    Ourpartners: 'Our partners are electronics experts who test and verify that each product is 100% functional before it leaves the factory. This is the reason you benefit from a minimum 1-Year warranty with the purchase of a refurbished device at YayTech.',
    Advantages: 'Advantages of YayTech',
    Peoplepowered: 'People powered',
    AtHuachuang: 'At YayTech, you buy and sell directly with other users. Cutting out the middleman means you join a second-hand equipment market with the best prices and highest value.',
    PayPalprotection: 'PayPal protection',
    Buyersand: 'Buyers and sellers transact safely and directly using PayPal. Extensive buyer and seller protections keep both parties safe.',
    confidence: 'Buy with confidence',
    Inorder: 'In order to ensure the safety of our market, we do not allow damaged items. We strictly require our partners to test and verify 100% of the functions of each product before leaving the factory.',
    Helpful: 'Helpful staff',
    Ouremployees: 'Our employees will pay close attention to product quality and transaction events, and will answer questions quickly.'
  },
  index: {
    SellerCenter: 'Seller Center',
    RegisterToSell: 'Register to sell',
    SellerPortal: 'Seller Portal',
    Underreview: 'Under Review',
    Refunding: 'Refunding',
    Returning: 'Returning',
    Refund_successful: 'Refund Successful',
    Refund_failed: 'Refund Failed',
    Review_failed: 'Review Failed',
    Under_review: 'Under Review',
    Return_completed: 'Refund Refused',
    Closed: 'Closed',
    Approved: 'Approved'
  }
}



// WEBPACK FOOTER //
// ./src/assets/lang/en-us/my.js